// TODO: This should be updated once we integrate authentication so that it returns the actual
// user's id token.
export const getAuthenticationToken = () => '';
